import { render, staticRenderFns } from "./operating-hours.vue?vue&type=template&id=b0f65e9e&"
import script from "./operating-hours.vue?vue&type=script&lang=js&"
export * from "./operating-hours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "operating-hours.vue"
export default component.exports